import React from 'react'
import { useStore } from 'src/state'
import Page from 'src/components/page'
import Section from 'src/components/section'
import Container from 'src/components/container'
import Link from 'src/components/link'
import CardGrid from 'src/components/card-grid'
import ProductCard from 'src/components/product-card'
import HeroSection from 'src/components/hero-section'

const ShopPage = () => {
  const {
    shopPage: { hero, featuredCollections },
  } = useStore()

  return (
    <Page className="page-shop">
      <HeroSection {...hero} />
      <div className="featured-collections">
        {featuredCollections.map((collection) => (
          <Section key={collection.id} className="featured-collection">
            <Container>
              <div className="section-header">
                <h3 className="section-title grey">{collection.title}</h3>
                <Link className="action-text" to={collection.shopUrl}>
                  {collection.viewCollectionText}
                </Link>
              </div>
              <CardGrid className="products" maxCards={6}>
                {collection.products.map((product) => (
                  <ProductCard key={product.id} {...product} />
                ))}
              </CardGrid>
            </Container>
          </Section>
        ))}
      </div>
    </Page>
  )
}

export default ShopPage
